import styles from "./SettingsGeneral.module.scss";
import useSettingsGeneral, {DATE_FORMATS, NUMBER_FORMATS} from "./useSettingsGeneral";
import Card from "../../../common/Card";
import Row from "react-bootstrap/Row";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import {AppStaticDropdown} from "../../../common/AppStaticDropdown";
import React from "react";
import moment from "moment";
import Button from "../../../common/Button";
import {LOCALES} from "../../../codes";
import {CurrenciesDropdown} from "../../../common/CurrenciesDropdown";
import {Content, ContentFixed} from "../../../common/Content";
import {SettingsMenuMobile} from "../Settings";
import {SettingsContent} from "../SettingsContent";
import {SettingsTopMenu} from "../SettingsTopMenu";

const SettingsGeneral = () => {
  const {
    t,
    submit,
    updateSetting,
    editedSettings
  } = useSettingsGeneral();

  const now = moment().set("month", 11).set("date", 30);

  const dateFormats = DATE_FORMATS.map(format => ({value: format, label: now.format(format)}));
  const numberFormats = Object.keys(NUMBER_FORMATS).map(k => ({value: k, label: k}));

  return (
    <Content>
      <ContentFixed>
        <SettingsTopMenu title="header_title_settings_general"/>

        <SettingsMenuMobile/>
      </ContentFixed>

      <SettingsContent>
        <Card>
          <Form onSubmit={submit} className={styles.form}>
            <Form.Group as={Row} className="mb-2" controlId="settings-locale">
              <Form.Label column sm={5} md={4} lg={4}>{t("settings_general_editor_field_locale")}</Form.Label>
              <Col sm={7} md={6} lg={4}>
                <AppStaticDropdown
                  value={editedSettings.locale}
                  choices={LOCALES}
                  onChange={updateSetting("locale")}
                />
              </Col>
            </Form.Group>

            <Form.Group as={Row} className="mb-2 mt-2" controlId="settings-date-format">
              <Form.Label column sm={5} md={4} lg={4}>{t("settings_general_editor_field_date_format")}</Form.Label>
              <Col sm={7} md={6} lg={4}>
                <AppStaticDropdown
                  value={editedSettings.dateFormat}
                  choices={dateFormats}
                  onChange={updateSetting("dateFormat")}
                />
              </Col>
            </Form.Group>

            <Form.Group as={Row} className="mb-2" controlId="settings-number-format">
              <Form.Label column sm={5} md={4} lg={4}>{t("settings_general_editor_field_number_format")}</Form.Label>
              <Col sm={7} md={6} lg={4}>
                <AppStaticDropdown
                  value={editedSettings.numberFormat}
                  choices={numberFormats}
                  onChange={updateSetting("numberFormat")}
                />
              </Col>
            </Form.Group>

            <Form.Group as={Row} className="mb-4" controlId="settings-currency-main">
              <Form.Label column sm={5} md={4} lg={4}>{t("settings_general_editor_field_currency_main")}</Form.Label>
              <Col sm={7} md={6} lg={4}>
                <CurrenciesDropdown value={editedSettings.currencyMain} onChange={updateSetting("currencyMain")}/>
              </Col>
            </Form.Group>

            <Form.Group as={Row}>
              <Col sm={5} md={4} lg={4}/>
              <Col sm={7} md={6} lg={4}>
                <Button type="submit">{t("btn_save_settings_general")}</Button>
              </Col>
            </Form.Group>
          </Form>
        </Card>
      </SettingsContent>
    </Content>
  );
};

export default SettingsGeneral;
